module.exports = __webpack_public_path__ + "img/logo.176a136a.png";